import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SVGIcon from '../../../shared/SVGIcon/SVGIconGenerator';
import { showSendConsultNowInvitationModal } from 'actions/modal';

export default function StartConsultNowButton(props) {
  const dispatch = useDispatch();
  const fetchingWaitingArea = useSelector((state) => state.waitingAreaReducer.fetchingWaitingArea);
  const isCurrentUserInCall = useSelector((state) => state.usersReducer.isInCall);
  const [btnEnabled, setBtnEnabled] = useState(false);

  useEffect(() => {
    setBtnEnabled(shouldBtnEnabled());
  }, [fetchingWaitingArea, props.waitingArea, isCurrentUserInCall]);

  const shouldBtnEnabled = () => {
    return (
      !fetchingWaitingArea &&
      !props.waitingArea.isSuspended &&
      props.waitingArea.operatingHours &&
      props.waitingArea.operatingHours.isOpen &&
      props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1 &&
      !isCurrentUserInCall
    );
  };

  const buttonOnClick = () => {
    if (btnEnabled) {
      return props.dispatch(showSendConsultNowInvitationModal(true));
    }
    return;
  };

  return (
    <button
      type="button"
      className={
        (btnEnabled ? 'waiting-area-green-bg color-white ' : 'color-info ') +
        'ui labeled icon button right-hand-side-button'
      }
      disabled={!btnEnabled}
      onClick={buttonOnClick}
    >
      <i
        aria-hidden="true"
        className="icon"
        style={{
          padding: '10px',
          width: '50px',
          height: '100%',
        }}
      >
        <SVGIcon name="consult-now" height={25} SVGprops={{ fill: btnEnabled ? '#ffffff' : '#111111' }} />
      </i>
      {APP.LANGUAGE.ViewOneWaitingArea.ConsultNow}
    </button>
  );
}
